import  ActionType  from './ActionType';

export const pollingIdsReducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_POLLING:
      return [...state].concat(action.data);
    case ActionType.SET_POLLING_UPDATE:
      return [...state, action.data];
    case ActionType.SET_POLLING_REMOVELS:
      return [...state.filter(poll => action.data.indexOf(poll) === -1)];

    default:
      return state;
  }
};
